// @flow
import { THEMATIC } from 'Client/cms/toolkit/constants';
import { ThematicLine } from 'Components/lines/thematic-line/ThematicLine';

import { thematicResolver } from './thematic.resolver';

export const thematicDescriptor = {
  name: THEMATIC,
  component: ThematicLine,
  resolve: thematicResolver.resolve,
};
